import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import type { ManageReleasePayloadType } from '@/types';

import useBreakpoint from '@/hooks/use-break-point';
import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';
import { ERROR_FEEDBACK } from '@/utils/constants';
import showReleaseToast from '@/utils/helpers/show-release-toast';

const useAddReleaseNote = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const isMobile = useBreakpoint('mobile');

  return useMutation<unknown, Error, ManageReleasePayloadType>({
    mutationKey: ['create-release-note'],
    mutationFn: async (newReleaseNoteData) => {
      const response = await axiosInstance.post(API_ROUTES.createReleaseNote(), newReleaseNoteData);

      return response.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['release-note-lists'] });
      showReleaseToast({
        variant: 'success',
        title: t('release_note.create_success_title'),
        description: t('release_note.create_success_description'),
        isMobile,
      });
    },

    onError: () => {
      showReleaseToast({
        variant: 'error',
        title: t(ERROR_FEEDBACK.general),
        description: t(ERROR_FEEDBACK.release_note.create_error),
        isMobile,
      });
    },
  });
};

export default useAddReleaseNote;
